import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WhiteLabelUserComment } from 'src/app/core/data/model';

@Component({
  selector: 'app-comment-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './comment-card.component.html',
  styleUrls: ['./comment-card.component.scss'],
})
export class CommentCardComponent implements OnInit {
  // Inputs
  @Input() comment: WhiteLabelUserComment;

  constructor() {}

  ngOnInit(): void {}
}
